import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Campaign from "./Campaign";
import CampaignMaker from "./CampaignMaker";
import { Header } from '../Header';
import { Footer } from '../Footer';
import { NavLink } from 'react-router-dom';

export default class Campaigns extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'campaign',
            systemModuleId: 31,
            data: null,
            loading: true,
            configName: 'campaigns_grid',
            moduleName: 'کمپین های تبلیغاتی',
        };
        this.state.filters = {
            isOrganization: props.IsOrganization,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Campaign IsOrganization={this.state.filters.isOrganization} Caller={this} Id={id} /> });
    }
    onAdd(service) {
        this.removeKeyDown();
        this.showComponents({ component: <CampaignMaker IsOrganization={this.state.filters.isOrganization} Service={service} InlineFilter={true} Caller={this} Emails={[]} /> });
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd(2)}><span>کمپین جدید پیامکی</span></a>
                                        </li>
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd(1)}><span>کمپین جدید ایمیلی</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    {this.isEmpty(this.state.data.records) ?
                        <div className="card card-bordered card-stretch">
                            <div className="card-inner-group">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text">
                                            <h6>توجه</h6>
                                            <p>شما در حال حاضر هیچ کمپینی ایجاد نکرده اید</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="row g-gs">
                            {this.state.data.records.map((record, index) =>
                                <div className="col-sm-6 col-lg-6 col-xxl-3">
                                    <div className="card card-bordered h-100">
                                        <div className="card-inner">
                                            <div className="project">
                                                <div className="project-head">
                                                    <a onClick={e => this.onEdit(record.id)} className="hand project-title">
                                                        <div className="project-info">
                                                            <h6 className="title">{record.title}</h6>
                                                            <span className="sub-text">تاریخ ایجاد: {record.createDateString}</span>
                                                            <span className="sub-text">تاریخ اتمام ارسال: {record.finishDateString}</span>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="project-meta">
                                                    <span className="hand">
                                                        <span className="nk-menu-text">تعداد ایمیل ها: {record.totalItem}</span>
                                                    </span>
                                                    <span className="hand text-success">
                                                        <span className="nk-menu-text">ارسال شده: {record.totalDone}</span>
                                                    </span>
                                                    <span className="hand text-warning">
                                                        <span className="nk-menu-text">وضعیت: {record.statusString}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}